import { memo, type Ref } from 'react';
import { cn } from '@/hen-ui/utils';
import { Heading } from '@/hen-ui/atomics/Heading';
import { Flex } from '@/hen-ui/composites/Flex';
import type { SponsoredCardProps } from './types';

type SponsoredCardBodyProps = Pick<
  SponsoredCardProps,
  'aboutHeading' | 'children' | 'expanded'
> & {
  /** Full blurb without line clamp (e.g. mobile details modal). */
  unclamped?: boolean;
  blurbRef?: Ref<HTMLDivElement>;
};

export const SponsoredCardBody = memo(function SponsoredCardBody({
  aboutHeading = 'About this School',
  children,
  expanded = false,
  unclamped = false,
  blurbRef,
}: SponsoredCardBodyProps) {
  if (!children) return null;

  return (
    <Flex direction='column' gap='xxs'>
      <Heading variant='h5' className='text-heading'>
        {aboutHeading}
      </Heading>
      <div
        ref={blurbRef}
        className={cn(
          'text-b5',
          !unclamped && 'line-clamp-[3]',
          !unclamped && expanded && 'md:line-clamp-none',
        )}
      >
        {children}
      </div>
    </Flex>
  );
});
